export const BET_WAS_OUTBID = 'App\\Notifications\\BetWasOutbid';
export const BET_CANCELED = 'App\\Notifications\\BetCanceled';
export const BET_IS_LEAD = 'App\\Notifications\\BetIsLead';
